import React from "react";
import "./styles.scss";
export default () => {
  return (
    <div className="loader">
      <div className="ripple-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
